import { parseRemarkHistoryEntries } from './transactionConstants';

export default function TransactionRemarkHistoryModal({ open, row, onClose }) {
  if (!open || !row) {
    return null;
  }

  const history = parseRemarkHistoryEntries(row.remark);

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>備註歷程</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <table className="data-table remark-history-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody>
              {history.length === 0 ? (
                <tr>
                  <td colSpan={2} className="empty-cell">
                    尚無備註歷程
                  </td>
                </tr>
              ) : (
                history.map((item, index) => (
                  <tr key={`${item.createTime}-${index}`}>
                    <td>{item.createTime || '—'}</td>
                    <td>{item.content || '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
